var React = require('react');

function ECoinbaseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16345 0 0 7.16344 0 16C0 24.8366 7.16345 32 16 32Z","fill":"#3259A5","key":0}),React.createElement("path",{"d":"M21.3923 17.0177C20.9145 19.5441 18.6929 21.4545 16.0226 21.4545C13.0032 21.4545 10.5562 19.0127 10.5562 15.9999C10.5562 12.9871 13.0032 10.5454 16.0226 10.5454C18.6929 10.5454 20.9145 12.4568 21.3923 14.9821H26.908C26.3937 9.43431 21.7165 5.09082 16.0226 5.09082C9.9839 5.09082 5.08984 9.97538 5.08984 15.9999C5.08984 22.0255 9.98498 26.909 16.0226 26.909C21.7165 26.909 26.3937 22.5655 26.908 17.0177H21.3923Z","fill":"white","key":1})]);
}

ECoinbaseInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ECoinbaseInline;

ECoinbaseInline.default = ECoinbaseInline;
